import { setRef } from './ref';

export default setRef;
